import { decode } from '../../../utils/base64Utils';
import { getBasketItems } from './basket-items';

/**
 * Extracts and transforms user related cookie values
 */
type CreateUserProfileProps = {
  cached_basket?: string;
  userGreeting?: string;
  shopperId?: string;
  signedIn?: string;
  'mt.v'?: string;
  hasNotification?: string;
};

export const createUserProfile = ({
  cached_basket: cachedBasket = '',
  userGreeting,
  shopperId,
  signedIn,
  'mt.v': monetateId,
  hasNotification,
}: CreateUserProfileProps = {}): UserProfile => {
  return {
    user: {
      basket: {
        items: getBasketItems(cachedBasket),
      },
      greeting: decode(userGreeting),
      signedIn: signedIn === 'true',
      shopperId,
      monetateId,
      notifications: {
        hasNotification: signedIn === 'true' && hasNotification === 'true',
      },
    },
  };
};
